import { achievementDefinitions } from "./achievementDefinitions";
import type { AchievementId, AchievementsState } from "./types";

const CURRENT_ACHIEVEMENT_IDS: ReadonlySet<AchievementId> =
  new Set<AchievementId>(
    achievementDefinitions.map((definition) => definition.id),
  );

export function normalizeAchievementId(value: string): AchievementId | null {
  const candidate = value;
  if (!CURRENT_ACHIEVEMENT_IDS.has(candidate as AchievementId)) {
    return null;
  }
  return candidate as AchievementId;
}

export function normalizeAchievementIds(
  values: Iterable<string>,
): AchievementId[] {
  const ids: AchievementId[] = [];
  const seen = new Set<AchievementId>();
  for (const value of values) {
    const id = normalizeAchievementId(value);
    if (id === null || seen.has(id)) continue;
    seen.add(id);
    ids.push(id);
  }
  return ids;
}

export function normalizeAchievementsState(state: {
  readonly unlockedIds: readonly string[];
  readonly seenIds: readonly string[];
}): AchievementsState {
  const unlockedIds = normalizeAchievementIds(state.unlockedIds);
  const unlockedSet = new Set<AchievementId>(unlockedIds);
  return {
    unlockedIds,
    seenIds: normalizeAchievementIds(state.seenIds).filter((id) =>
      unlockedSet.has(id),
    ),
  };
}
